import { render, staticRenderFns } from "./BaseTextInput.vue?vue&type=template&id=674b8172&scoped=true&"
import script from "./BaseTextInput.vue?vue&type=script&lang=js&"
export * from "./BaseTextInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextInput.vue?vue&type=style&index=0&id=674b8172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b8172",
  null
  
)

export default component.exports